module.exports = __webpack_public_path__ + "assets/8efee5c45bbfdd52eec7a8a0eec72ec3.js";